(function () {
  if (window.__cardSwatchInit) return;
  window.__cardSwatchInit = true;

  function findImg(sw) {
    var wrap = sw.closest('.card-wrapper');
    return wrap ? wrap.querySelector('.card__media img') : null;
  }

  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('.card-swatch');
    if (!sw) return;
    sw.style.boxShadow = '0 0 0 2px rgb(var(--color-background)), 0 0 0 4px rgb(var(--color-foreground))';
    sw.style.transform = 'scale(1.05)';
    var url = sw.getAttribute('data-variant-image');
    if (!url) return;
    var img = findImg(sw);
    if (!img) return;
    if (img.dataset.swatchOrigSrc === undefined) {
      img.dataset.swatchOrigSrc = img.getAttribute('src') || '';
      img.dataset.swatchOrigSrcset = img.getAttribute('srcset') || '';
    }
    img.setAttribute('srcset', '');
    img.setAttribute('src', url);
  });

  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest('.card-swatch');
    if (!sw) return;
    sw.style.boxShadow = '';
    sw.style.transform = '';
    var related = e.relatedTarget;
    if (related && related.closest && related.closest('.card-swatch[data-variant-image]')) return;
    if (!sw.getAttribute('data-variant-image')) return;
    var img = findImg(sw);
    if (!img || img.dataset.swatchOrigSrc === undefined) return;
    img.setAttribute('src', img.dataset.swatchOrigSrc);
    img.setAttribute('srcset', img.dataset.swatchOrigSrcset || '');
  });
})();